import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  data: {
    name: '',
    type: 'text',
    resultType: 'text',
  },
  openForm: null,
  error: null,
  status: null,
}

const slice = createSlice({
  name: 'updateColumn',
  initialState,
  reducers: {
    formInit: (state, action) => {
      state.data.name = action.payload.name
      state.data.type = action.payload.type
      state.data.resultType = action.payload.resultType
    },
    changeName: (state, action) => {
      state.data.name = action.payload.name
    },
    changeType: (state, action) => {
      state.data.type = action.payload.type
    },
    changeResultType: (state, action) => {
      state.data.resultType = action.payload.resultType
    },
    setOpenForm: (state, action) => {
      state.data.name = action.payload.name
      state.data.type = action.payload.type
      state.data.resultType = action.payload.resultType
      state.openForm = action.payload.openForm
    },
    resetForm: () => initialState,
    changeRequestStatus: (state, action) => {
      state.status = action.payload.status
    },
  },
})

const selectSlice = (state) => state.updateColumn
export const selectFormData = (state) => selectSlice(state).data
export const selectError = (state) => selectSlice(state).error
export const selectRequestStatus = (state) => selectSlice(state).status
export const selectOpenForm = (state) => selectSlice(state).openForm

const { reducer, actions } = slice

export const { changeRequestStatus, formInit, changeResultType, changeType, resetForm, changeName, setOpenForm } =
  actions

export default reducer
